import { formatDateTimeISTWithYear } from '../../utils/formatIST';

// Single selector for "when did this consent reach its status" — list and detail both use it.
// Keyed off the backend displayStatus; REQUESTED / SUBMIT_FAILED have no stamp.
const STAMP = {
  GRANTED: ['Granted', 'grantedAt'],
  DENIED: ['Denied', 'deniedAt'],
  REVOKED: ['Revoked', 'revokedAt'],
  EXPIRED: ['Expired', 'expiredAt'],
};

/** @returns {{ label: string, at: string } | null} `at` is IST-formatted. */
export function statusTimeLine(consent) {
  const entry = STAMP[consent?.displayStatus];
  if (!entry) return null;
  // Expired with no stamp from ABDM: the access-until time is when it ended.
  const at = formatDateTimeISTWithYear(consent[entry[1]] || (consent.displayStatus === 'EXPIRED' ? consent.expiresAt : null));
  return at ? { label: entry[0], at } : null;
}
